module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"segment":{"prd":"Produção","tst":"Teste"},"info":"Conta de Produção","cta":{"createTestAccount":"Criar Conta de Teste"}},"en-US":{"segment":{"prd":"Production","tst":"Test"},"info":"Production Account","cta":{"createTestAccount":"Create Test Account"}}}')
  delete Component.options._Ctor
}
